module.exports = __webpack_public_path__ + "static/media/ml5.2707b59c.jpg";